<template>
    <div>
        <p>Thank you! We will send an email to let you know when your post will go live.</p>
        <br>
        <br>
        <small>Powered By ParkAve &amp; Broadstreet</small>
    </div>
</template>

<script>
  export default {
    name: 'UpdateSuccess'
  }
</script>

<style scoped>
    div {
        position: absolute;
        text-align: center;
        margin: auto;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 50%;
        height: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/components/UpdateSuccess.vue